import React, { useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { navigatePage } from '@cap/share/src/utils/navigation';
import { logger, lx } from '@cap/rzmt-core';
import { getGrayTest } from '@cap/share/src/apis/course';
import { selectCurModuleContentData, homeDataLoadStatus } from '@/pages/home/homeCourseData';
import { useAppSelector } from '@/store/hooks';
import { IModuleContentData } from '@/utils/type';
import { LoadStatus } from '@/components/LoadPlaceholder';
import { ENU_COURSE_TYPE } from '@/utils/course';
import { EnumModuleCode } from '@/utils/const';
import 'swiper/css';
import 'swiper/css/navigation';
import './index.less';

const PopularCourses: React.FC = () => {
  const pularLiveData = useAppSelector(selectCurModuleContentData);
  const loadStatus = useAppSelector(homeDataLoadStatus);

  const popularClick = () => {
    lx.moduleClick({
      bid: 'b_donation_4skt1u8d_mc',
    });
  };

  const [dataList, setDataList] = useState<IModuleContentData>(() => {
    const targetData = pularLiveData.find((c) => c.moduleCode === EnumModuleCode.PopularCourse);

    if (targetData) {
      return targetData;
    }
    return {
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        totalPageCount: 0,
      },
      courseList: [],
      moduleId: 0,
      moduleCode: EnumModuleCode.PopularCourse,
    };
  });

  useEffect(() => {
    const item = pularLiveData.find((c) => c.moduleCode === EnumModuleCode.PopularCourse);
    if (!item) return;
    const { page } = item;
    const { pageNo } = page;
    setDataList((oldData) => {
      if (pageNo === 1) return item;
      return {
        ...oldData,
        courseList: [...oldData.courseList, ...item.courseList],
      };
    });
  }, [pularLiveData]);

  const [realIndex, setRealIndex] = useState<number>(1);
  const handleSlideChange = (swiper) => {
    setRealIndex(swiper.realIndex);
  };

  const handleSlideClick = async (item) => {
    const { id, type, shortUrl, tenantId } = item;
    let urlPrefix = '/i/college';

    if ([ENU_COURSE_TYPE.VIDEO, ENU_COURSE_TYPE.ARTICLE].includes(type)) {
      try {
        const res = await getGrayTest({ tenant: shortUrl, tenantId });
        const { gray } = res.data || { gray: false };
        if (gray) {
          urlPrefix = '/web';
        }
      } catch (err) {
        logger.error(`灰度接口报错 ${err}`);
      }
    }
    const url = `${urlPrefix}/${shortUrl}/${ENU_COURSE_TYPE[type]}/${id}`;
    navigatePage(url, {
      windowOpen: true,
    });
  };

  return (
    <div className="popular-courses" onClick={() => popularClick()}>
      <div className="top-title">
        <span>成长系列课</span>
        <div className="pagination">
          {dataList.courseList.length ? realIndex + 1 : 0}/{dataList.courseList.length}
        </div>
      </div>
      <div className="courses">
        {loadStatus === LoadStatus.SUCCESS ? (
          <Swiper
            className="mySwiper"
            navigation
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            onSlideChange={handleSlideChange} // 监听滑块切换
            loop
            autoplay={{
              delay: 5000, // 设置每隔 3 秒自动切换一次
              disableOnInteraction: false, // 滑动时不会停止自动轮播
            }}
          >
            {dataList.courseList.map((item, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <SwiperSlide key={index} onClick={() => handleSlideClick(item)}>
                  <img src={item.coverImageUrl} alt="" />
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <img
            className="loading-icon"
            src="//s3plus-img.meituan.net/v1/mss_a15b7cd66e264e09b68e65865d5f8e2b/mtdx/mtdx-loading.gif"
            alt="loading"
          />
        )}
      </div>
    </div>
  );
};

export default PopularCourses;
